import { UserCertificatesTable } from './table/table';
import { LmsUserCertificateListFilterInput } from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserCertificates } from 'src/hooks/query/lms/certificates/use-user-certificates';
import { UserCertificateListItem } from 'src/components/organisation/manage-otps/user-details/user-certificates/types';

type UserCertificatesProps = {
  userId: string;
  withoutActions?: boolean;
};

const PAGINATION_LIMIT = 10;

export const UserCertificates = ({
  userId,
  withoutActions = false,
}: UserCertificatesProps) => {
  const { t } = useTranslation();

  const { page, setPage, filter } = useTable<
    LmsUserCertificateListFilterInput,
    Record<any, any>
  >({
    defaultFilter: {
      userId: userId,
    },
  });

  const {
    loading,
    data: userCertificates,
    totalCount,
  } = useUserCertificates({
    filter,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
  });

  return (
    <UserCertificatesTable
      title={t('manage-otps.details.user-certificates')}
      loading={loading}
      data={userCertificates as UserCertificateListItem[]}
      options={{
        page,
        count: totalCount,
        rowsPerPage: PAGINATION_LIMIT,
        onChangePage: setPage,
        enableNestedDataAccess: '.',
      }}
      withoutActions={withoutActions}
    />
  );
};
